import { render, staticRenderFns } from "./contact-menu.vue?vue&type=template&id=31ecad32&scoped=true"
import script from "./contact-menu.vue?vue&type=script&lang=js"
export * from "./contact-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ecad32",
  null
  
)

export default component.exports